import { render } from "./WebsiteInfrastructureDraft.vue?vue&type=template&id=168dba7c&scoped=true"
import script from "./WebsiteInfrastructureDraft.vue?vue&type=script&lang=js"
export * from "./WebsiteInfrastructureDraft.vue?vue&type=script&lang=js"

import "./WebsiteInfrastructureDraft.vue?vue&type=style&index=0&id=168dba7c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-168dba7c"]])

export default __exports__